module.exports = __webpack_public_path__ + "assets/img/ad0ea5a0c16aa6405e04d6058675a2bf.webp";